import { clsx } from "clsx";
import { forwardRef } from "react";

import { Loader } from "@/components/ui/status/Loader/Loader";
import { Typography } from "@/components/ui/text/Typography/Typography";

interface ButtonContentProps {
  text: string;
  isLoading?: boolean;
  icon?: React.FC<React.SVGProps<SVGSVGElement>>;
  iconClassName?: string;
  hideText?: boolean;
  className?: string;
  variant?: "prominent-2" | "default";
  size?: "label-2" | "body-3" | "body-4" | "label-3" | "label-4" | "label-5" | "label-6";
}

export const ButtonContent = forwardRef<HTMLHeadingElement, ButtonContentProps>(
  ({ text, isLoading, icon: Icon, iconClassName = "h-6 w-6", hideText, className, variant, size }, ref) => {
    let iconOrLoader = null;
    if (isLoading) {
      iconOrLoader = <Loader className="flex-shrink-0" />;
    } else if (Icon) {
      iconOrLoader = <Icon className={clsx("flex-shrink-0", iconClassName)} />;
    }

    return (
      <>
        {iconOrLoader}
        {text && (
          <Typography
            size={size ?? "label-2"}
            variant={variant ?? "default"}
            className={clsx(
              `t:truncate hyphens-auto ${hideText ? "sr-only" : ""} font-body-prominent-1 font-secondary`,
              className,
            )}
            ref={ref}
          >
            {text}
          </Typography>
        )}
      </>
    );
  },
);
